import { NuveiApplePayForm } from '@/components/PaymentForms/NuveiApplePayForm';
import { ApplePayTabFallback } from '@/components/Wallets/ApplePayTabFallback/ApplePayTabFallback';
import { useApplePayTabFallbackGate } from '@/hooks/useApplePayTabFallbackGate';
import type { ExpressCheckoutComponentProps } from '@/types/expressCheckout';
/** Express-row adapter — keeps `expressPayment` aligned with Adyen/Stripe wallet modules. */
export const NuveiApplePay = (props: ExpressCheckoutComponentProps) => {
  // iOS <= 16 cross-origin iframe (`ApplePaySession.canMakePayments()` can
  // never pass inside the frame), or Apple already rejected this page's
  // merchant domain. Render the new-tab fallback instead — it reports
  // `onReady(true)` so the express slot doesn't collapse.
  if (useApplePayTabFallbackGate()) {
    return <ApplePayTabFallback {...props} />;
  }
  return <NuveiApplePayForm {...props} />;
};
